/** Aligné sur le backend Laravel (StreamReport::REASONS). */
export const STREAM_REPORT_REASONS: ReadonlyArray<{ code: string; label: string }> = [
  { code: 'violent', label: 'Contenu violent, haineux ou dérangeant' },
  { code: 'adult', label: 'Contenu réservé aux adultes' },
  { code: 'harassment', label: 'Harcèlement' },
  { code: 'spam_scam', label: 'Spam / arnaque' },
  { code: 'other', label: 'Autre' },
];

export function streamReportReasonLabel(code: string): string {
  return STREAM_REPORT_REASONS.find((r) => r.code === code)?.label ?? code;
}
